module.exports = __webpack_public_path__ + "static/media/imageskybanner3.b5cd28e0.jpeg";